<!-- routify:options showInNavigation=false -->
<!-- routify:options title='Task details' -->
<!-- routify:options index=2 -->
<script>
	import { params, url, goto } from '@sveltech/routify'
	import { onMount } from 'svelte'
    import { fetchJSON } from '../../../../common/Backend'
    import  { Box } from 'totalinvoice-frontend-core'
    import { t, dt, dateStringOptionsLong, BackButton }  from 'totalinvoice-frontend-core'
    import CustomerForm from '../../../../components/CustomerForm.svelte'
    import InvoiceList from '../../../../components/InvoiceList.svelte'
		import ReceiptsForm from '../../../../components/ReceiptsForm.svelte'

	let task

 let status = null

	onMount(async () => {
		const res = await fetchJSON('task/' + $params.id)
		if (res.status === 'ok') {
			task = res.data
		} else {
			// TODO show error notification
		}
		if (task.invoiceRequest && task.invoiceRequest.status) {
								status = task.invoiceRequest.status
							
            }
	})
</script>


{#if task}
	<style>
		.flex-align-top {
			display: flex;
			align-items: top;
		}
	</style>
	<h2 class="title is-2 is-spaced page-title">
		{$t('Invoice Request Details')}
	</h2>

	{#if task.invoiceRequest}
		<div class="columns is-multiline">
			<div class="column is-full-tablet is-half-desktop">
				<Box title={$t("Status")} icon="fas fa-info-circle">
					<div class="field is-horizontal">
						<div class="field-label">
							<label for class="label">{$t('Date')}</label>
						</div>
						<div class="field-body">
							<div class="field">
								<div class="control">
									{$dt(new Date(task.invoiceRequest.created), dateStringOptionsLong)}
								</div>
							</div>
						</div>
					</div>
					<div class="field is-horizontal">
						<div class="field-label">
							<label for class="label">{$t('Status')}</label>
						</div>
						<div class="field-body">
							<div class="field">
								<div class="control flex-align-top">
									<span class="icon is-medium mr-1"><i
											class="{status.icon} fa-lg"
											aria-hidden="true" /></span>
									<span>{status}</span>
								</div>
							</div>
						</div>
					</div>
				</Box>
			</div>

			<div class="column is-full-tablet is-half-desktop">
				<Box title={$t("Address")} icon="fas fa-building">
					<CustomerForm
						customer={task.invoiceRequest.customerInfo}
						editable={false} />
				</Box>
			</div>

			<div class="column is-full">
				<Box title={$t("Receipts")} icon="fas fa-receipt">
					<ReceiptsForm
						receipts={task.invoiceRequest.receiptList}
						editable={false}
						showErrors={false} />
				</Box>
			</div>

			<div class="column">
				<Box title={$t("Documents")} icon="fas fa-file">
					<InvoiceList
						invoiceList={task.invoiceRequest.invoices}
						searchable={false}
						sortable={false} />
				</Box>
			</div>
		</div>
	{:else}
		<E404 />
	{/if}

	<div class="mt-6">
		<BackButton on:click={() => $goto('../../list')} />
	</div>
{/if}
